import React from 'react';
import { obfuscatedCoordinates } from '../../util/maps';
import { IconSpinner, Map } from '../../components';
import config from '../../config';
import css from './EntityLocationFormFields.css';
import classNames from 'classnames';

export default ({
    geolocationMaybe,
    predictionInProgress,
    mapCustomProps,
    rootClassName,
    children,
}) => {
    if (predictionInProgress) return <IconSpinner />;
    if (!geolocationMaybe) return null;

    const cacheKey = geolocationMaybe
        ? `${geolocationMaybe.origin.lat}_${geolocationMaybe.origin.lng}`
        : null;

    const mapProps = geolocationMaybe
        ? { obfuscatedCenter: obfuscatedCoordinates(geolocationMaybe.origin, cacheKey) }
        : {};

    return (
        <section
            className={classNames(css.mapSection, {
                [rootClassName]: !!rootClassName,
            })}
        >
            <Map
                {...mapProps}
                {...mapCustomProps}
                mapsConfig={{
                    ...config.maps,
                    fuzzy: {
                        ...config.maps.fuzzy,
                        enabled: true,
                        defaultZoomLevel: 15,
                        offset: 500,
                    },
                }}
            >
                {children}
            </Map>
        </section>
    );
};
